@use '@lib/assets/styles/main.scss' as *;

.filterWrap {
  padding-bottom: 16px;
}

.filter {
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 16px;
  align-items: center;
  justify-content: space-between;
}

.filterRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dateRangePickerCol {
  width: 288px; // DatePicker drop-down width
}

.siteAreaFilter {
  padding: 8px 16px;
}

.siteAndAreaFormActions {
  align-self: flex-end;
  margin-top: -32px;
  position: relative;
  z-index: 2;
}

.optionWrap {
  position: relative;
  &.optionWrapWithDelete {
    padding-right: 48px;
  }
}

.optionDeleteBtn {
  position: absolute;
  top: 8px;
  right: 0;
}

.optionAddBtn {
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  justify-content: space-between;
}

.periodFormActions {
  padding: 0 16px 16px;
}

.optionAddBtnWithTopPadding {
  position: relative;
}

.actions {
  padding-top: 0;
}
